import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'caret-up-icon',
  templateUrl: './caret-up-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CaretUpIconComponent {}
